if (!customElements.get("lsg-carousel-rebuild")) customElements.define("lsg-carousel-rebuild", class LSGCarouselRebuild extends HTMLElement {
  constructor(){
      super();
      this.selectors = {
          carouselSectionEls: ".lsg-carousel-rebuild"
      };
      this.carouselSectionEls = this.querySelectorAll(this.selectors.carouselSectionEls);
      this.init();
      
      // Initialize keyboard handler
      this.initGlobalKeyboard();
  }
  
  /* GLOBAL KEYBOARD CONTROLLER */
  initGlobalKeyboard() {
      console.log('[Carousel] Keyboard handler initialized');
      
      document.addEventListener('keydown', (e) => {
          // Only handle arrow keys
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          
          console.log(`[Carousel] Arrow key pressed: ${e.key}`);
          
          const active = document.activeElement;
          
          // Don't interfere with input fields
          if (
              active &&
              (
                  active.tagName === 'INPUT' ||
                  active.tagName === 'TEXTAREA' ||
                  active.isContentEditable ||
                  active.closest('input') ||
                  active.closest('textarea')
              )
          ) {
              console.log('[Carousel] Ignoring arrow key - input field is focused');
              return;
          }
          
          // Find the best carousel to control
          let targetCarousel = null;
          let targetWrapper = null;
          
          // First, check if a carousel wrapper is focused
          if (active && active.classList.contains('lsg-carousel-rebuild__carousel-wrapper')) {
              console.log('[Carousel] Carousel wrapper is focused');
              const carouselElement = active.querySelector('[lsg-carousel]');
              if (carouselElement) {
                  const flickityInstance = window.Flickity.data(carouselElement);
                  if (flickityInstance && flickityInstance.cells && flickityInstance.cells.length > 0) {
                      targetCarousel = flickityInstance;
                      targetWrapper = active;
                      console.log('[Carousel] Using focused carousel');
                  }
              }
          }
          
          // If no focused carousel, find the most visible one in viewport
          if (!targetCarousel) {
              console.log('[Carousel] No focused carousel, searching for visible carousel...');
              const allCarouselWrappers = document.querySelectorAll('.lsg-carousel-rebuild__carousel-wrapper');
              console.log(`[Carousel] Found ${allCarouselWrappers.length} carousel wrappers`);
              
              let bestMatch = null;
              let bestVisibility = 0;
              
              for (const carouselWrapper of allCarouselWrappers) {
                  const rect = carouselWrapper.getBoundingClientRect();
                  const isVisible = rect.top < window.innerHeight && 
                                  rect.bottom > 0 && 
                                  rect.left < window.innerWidth && 
                                  rect.right > 0;
                  
                  if (!isVisible) continue;
                  
                  const carouselElement = carouselWrapper.querySelector('[lsg-carousel]');
                  if (!carouselElement) continue;
                  
                  const flickityInstance = window.Flickity.data(carouselElement);
                  
                  if (!flickityInstance || !flickityInstance.cells || flickityInstance.cells.length === 0) {
                      continue;
                  }
                  
                  // Calculate visibility percentage
                  const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
                  const visibleWidth = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
                  const totalArea = rect.height * rect.width;
                  const visibility = totalArea > 0 ? (visibleHeight * visibleWidth) / totalArea : 0;
                  
                  console.log(`[Carousel] Found visible carousel with ${(visibility * 100).toFixed(1)}% visibility`);
                  
                  if (visibility > bestVisibility) {
                      bestVisibility = visibility;
                      bestMatch = {
                          carousel: flickityInstance,
                          wrapper: carouselWrapper
                      };
                  }
              }
              
              if (bestMatch) {
                  targetCarousel = bestMatch.carousel;
                  targetWrapper = bestMatch.wrapper;
                  console.log(`[Carousel] Selected carousel with ${(bestVisibility * 100).toFixed(1)}% visibility`);
              } else {
                  console.log('[Carousel] No visible carousel found');
              }
          }
          
          // If we found a carousel, control it
          if (!targetCarousel) {
              console.log('[Carousel] No carousel to control');
              return;
          }
          
          console.log(`[Carousel] Controlling carousel with ${targetCarousel.cells.length} cells`);
          
          // Prevent default browser behavior
          e.preventDefault();
          e.stopPropagation();
          
          try {
              // Control the carousel
              if (e.key === 'ArrowLeft') {
                  console.log('[Carousel] Moving to previous slide');
                  targetCarousel.previous();
              } else if (e.key === 'ArrowRight') {
                  console.log('[Carousel] Moving to next slide');
                  targetCarousel.next();
              }
              console.log('[Carousel] Carousel navigation successful');
          } catch (error) {
              console.error('[Carousel] Error controlling carousel:', error);
          }
      }, true);
  }
  
  init() {
      this.carouselSectionEls.forEach((carouselSectionEl)=>{
          buildCarousel(carouselSectionEl);
      });
      function buildCarousel(carouselSectionEl) {
          const sectionId = carouselSectionEl.getAttribute(`data-section-id`), carouselSettings = JSON.parse(document.getElementById(`CarouselSettings-${sectionId}`).textContent), carouselActualEl = carouselSectionEl.querySelector(`[lsg-carousel]`);
          const carouselWrapper = carouselSectionEl.querySelector('.lsg-carousel-rebuild__carousel-wrapper');
          const videoCards = carouselSectionEl.querySelectorAll('[lsg-carousel-video-card]');
          let carouselEl;
          if (carouselActualEl) {
              // Make carousel wrapper focusable for keyboard control
              if (carouselWrapper && !carouselWrapper.hasAttribute('tabindex')) {
                  carouselWrapper.setAttribute('tabindex', '0');
                  carouselWrapper.setAttribute('role', 'region');
                  carouselWrapper.setAttribute('aria-label', 'Carousel');
              }
              
              let carouselNavEl = carouselSectionEl.querySelector(`[lsg-carousel-nav]`), navPrevEl = carouselNavEl.querySelector(`[lsg-carousel-nav-prev]`), navDotsEl = carouselNavEl.querySelector(`[lsg-carousel-nav-dots]`), navDotEls = carouselNavEl.querySelectorAll(`[lsg-carousel-nav-dot]`), navNextEl = carouselNavEl.querySelector(`[lsg-carousel-nav-next]`);
              function initCarousel(element, settings) {
                  // Non-customizable settings
                  settings.prevNextButtons = false // custom
                  ;
                  // settings.pageDots = false // custom
                  settings.percentPosition = false;
                  settings.imagesLoaded = true
                  settings.on = {
                      change: (index)=>{
                          updateNav(index);
                      }
                  };
                  carouselEl = new window.Flickity(element, settings);
                  carouselEl.on('dragStart', () => {
                      carouselEl.slider.style.pointerEvents = 'none';
                  });
                  carouselEl.on('dragEnd', () => {
                      carouselEl.slider.style.pointerEvents = '';
                  });

                  carouselEl.on(`settle`, (e) => {
                      console.log(`[NSS] Carousel settled`);
                      widthChecker();
                      setSliderHeightToMax(carouselEl);
                  });
                  setTimeout(() => {
                      window.dispatchEvent(new Event('resize'));
                  }, 100);
              }
              initCarousel(carouselActualEl, carouselSettings);
              initNav(carouselSectionEl, carouselSettings);
              /* Width Checker */ function widthChecker() {
                  if (carouselEl && carouselActualEl.clientWidth > carouselEl.slideableWidth) {
                      carouselEl.cells.forEach((cell)=>cell.element.style.height = "");
                      carouselEl.destroy();
                  } else if (!carouselEl || !carouselEl.isActive) carouselEl = new window.Flickity(carouselActualEl, carouselSettings);
              }
              /* Height Handler */ function setSliderHeightToMax(carouselEl) {
                  carouselEl.cells.forEach((cell)=>cell.element.style.height = "");
                  let heights = carouselEl.cells.map((cell)=>cell.element.offsetHeight), max = Math.max.apply(Math, heights);
                  carouselEl.cells.forEach((cell)=>cell.element.style.height = max + "px");
              }
              /* Resize Handling */ window.addEventListener("resize", ()=>{
                  carouselEl.resize();
                  widthChecker();
                  setSliderHeightToMax(carouselEl);
              });
              /* Nav Handling */ function initNav(element, settings) {
                  carouselNavEl = element.querySelector(`[lsg-carousel-nav]`);
                  navPrevEl = carouselNavEl.querySelector(`[lsg-carousel-nav-prev]`);
                  navDotsEl = carouselNavEl.querySelector(`[lsg-carousel-nav-dots]`);
                  navDotEls = carouselNavEl.querySelectorAll(`[lsg-carousel-nav-dot]`);
                  navNextEl = carouselNavEl.querySelector(`[lsg-carousel-nav-next]`);
                  updateNav(settings.initialIndex);
              }
              function updateNav(index) {
                  navDotEls.forEach((navDotEl)=>{
                      navDotEl.parentElement.classList.remove(`lsg-dot-selected`);
                  });
                  const currentNavDotEl = carouselNavEl.querySelector(`[lsg-carousel-nav-dot-index="${index}"]`);
                  if (currentNavDotEl) currentNavDotEl.parentElement.classList.add(`lsg-dot-selected`);
                  if (navPrevEl && navNextEl) {
                      navPrevEl.removeAttribute(`disabled`);
                      navNextEl.removeAttribute(`disabled`);
                      if (!carouselEl?.isWrapping && index === 0) navPrevEl.setAttribute(`disabled`, true);
                      else if (!carouselEl?.isWrapping && index === carouselEl?.cells.length - 1) navNextEl.setAttribute(`disabled`, true);
                  }
              }
              if (navPrevEl && navNextEl) {
                  navPrevEl.addEventListener(`click`, (e)=>{
                      carouselEl.previous();
                  });
                  navNextEl.addEventListener(`click`, (e)=>{
                      carouselEl.next();
                  });
              }
              navDotEls.forEach((navDotEl)=>{
                  navDotEl.addEventListener(`click`, (e)=>{
                      const index = navDotEl.getAttribute(`lsg-carousel-nav-dot-index`);
                      carouselEl.select(index);
                  });
              });
          }
          videoCards.forEach(videoCard => {
              const videoTriggers = videoCard.querySelectorAll('[lsg-carousel-video-trigger]');
              const videoEl = videoCard.querySelector('video');
              if (videoEl) {
                  videoEl.addEventListener('play', () => {
                      videoCards.forEach(card => {
                          const cardVideo = card.querySelector('video');
                          const cardVideoAuto = cardVideo.getAttribute(`autoplay`);
                          if (cardVideo && cardVideo != videoEl) {
                              cardVideo.muted = true;
                          }
                          if (cardVideo && cardVideo != videoEl && !cardVideoAuto) {
                              cardVideo.pause();
                          }
                      });
                  });
                  
                  const videoElAuto = videoEl.getAttribute(`autoplay`);
                  if (videoElAuto) {
                    videoEl.addEventListener('click', () => {
                      videoEl.muted = !videoEl.muted;
                      videoCards.forEach(card => {
                          const cardVideo = card.querySelector('video');
                          // const cardVideoAuto = cardVideo.getAttribute(`autoplay`);
                          if (cardVideo && cardVideo != videoEl) {
                              cardVideo.muted = true;
                          }
                      });
                    });
                  }

                  videoTriggers.forEach(trigger => {
                      trigger.addEventListener('click', (e) => {
                          videoCard.classList.add('video--played');
                          videoEl.controls = true;
                          videoEl.muted = false;
                          videoEl.play();
                      });
                  });
              }
          });
      }

  }
});